<template>
  <div>
    <DashboardHeader
      heading="Service partner profiles"
      paragraph="Manage and curate the profiles of your partners"
    >
      <div class="flex items-center" v-click-outside="closeDropdown">
        <a
          class="flex items-center pl-3 underline text-violet"
          target="_blank"
          :href="$store.getters.agenciesDirectoryBaseUrl"
        >
          <span>Directory</span>
          <LinkIcon></LinkIcon>
        </a>
        <Button
          v-on:button-click="$router.push('/invite/agency')"
          bMargin="left"
        >
          Invite partner
        </Button>
      </div>
    </DashboardHeader>

    <template v-if="loading">
      <Logo />
    </template>
    <template v-else>
      <TableToolbar :query="filters.name.value" @update-query="filterRows">
        <div>
          <label style="margin-bottom: 0" class="mr-xs">
            <div class="select select-mb-0">
              <select
                @change="filterRows(['tierName'], $event.target.value, 'tier')"
              >
                <option selected="selected" value="">Tier</option>
                <option
                  :selected="filters.tier.value === tier.name"
                  v-for="tier in tiers"
                  :key="tier.order"
                  :value="tier.name"
                  >{{ tier.name }}</option
                >
              </select>
            </div>
          </label>
          <label style="margin-bottom: 0" class="mr-xs">
            <div class="select select-mb-0">
              <select
                @change="filterRows(['status'], $event.target.value, 'status')"
              >
                <option selected="selected" value>Status</option>
                <option :selected="filters.status.value == 'P'" value="P"
                  >Public</option
                >
                <option :selected="filters.status.value == 'S'" value="S"
                  >Searchable</option
                >
                <!-- <option :selected="filters.status.value == 'N'" value="N">Initial</option> -->
                <option :selected="filters.status.value == 'H'" value="H"
                  >Hidden</option
                >
                <option :selected="filters.status.value == 'I'" value="I"
                  >Invited</option
                >
              </select>
            </div>
          </label>
          <!-- New dashboard select, has problem with :selected -->
          <!-- <Select
            style="width:120px; margin-right: 8px;"
            placeholder="Status"
            @input-change="filterRows(['status'], $event.value, 'status')"
            :options="
            [
              {
                name: 'Public',
                value: 'P'
              },
              {
                name: 'Searchable',
                value: 'S'
              },
              {
                name: 'Hidden',
                value: 'H'
              },
              {
                name: 'Invited',
                value: 'I'
              },
            ]"
            :selected="filters.completeness.value"
          ></Select> -->
          <label style="margin-bottom: 0">
            <div class="select select-mb-0">
              <select
                @change="
                  filterRows(
                    ['completeness'],
                    $event.target.value,
                    'completeness'
                  )
                "
              >
                <option selected="selected" value>Completeness %</option>
                <option :selected="filters.completeness.value == 20" value="20"
                  >20%</option
                >
                <option :selected="filters.completeness.value == 40" value="40"
                  >40%</option
                >
                <option :selected="filters.completeness.value == 60" value="60"
                  >60%</option
                >
                <option :selected="filters.completeness.value == 80" value="80"
                  >80%</option
                >
                <option
                  :selected="filters.completeness.value == 100"
                  value="100"
                  >100%</option
                >
              </select>
            </div>
          </label>
        </div>
      </TableToolbar>
      <div class="mb-lg">
        <v-table
          key="x"
          :data="rows"
          :filters="filters"
          :currentPage.sync="currentPage"
          :pageSize="pageSize"
          :totalItemsInput="count"
          class="table table-bordered"
          @totalPagesChanged="totalPages = $event"
        >
          <thead slot="head">
            <v-th
              v-on:sortChange="sortChange"
              v-for="(column, i) in columns"
              :key="i"
              :defaultSort="column.name === 'agencyName' ? 'asc' : undefined"
              :customSort="
                column.name === 'agencyName'
                  ? sortAgenciesAndInvites
                  : undefined
              "
              :sortKey="column.name"
              class="mb-xxs relative grey-background fs-sm"
            >
              <svg
                @click="modalShowing = true"
                class="absolute cursor-pointer"
                style="left: -3px; top: 16px;"
                v-if="column.name === 'completeness'"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.4001 7.99998C14.4001 9.69736 13.7258 11.3252 12.5256 12.5255C11.3253 13.7257 9.69748 14.4 8.0001 14.4C6.30271 14.4 4.67485 13.7257 3.47461 12.5255C2.27438 11.3252 1.6001 9.69736 1.6001 7.99998C1.6001 6.30259 2.27438 4.67472 3.47461 3.47449C4.67485 2.27426 6.30271 1.59998 8.0001 1.59998C9.69748 1.59998 11.3253 2.27426 12.5256 3.47449C13.7258 4.67472 14.4001 6.30259 14.4001 7.99998ZM8.8001 4.79998C8.8001 5.01215 8.71581 5.21563 8.56578 5.36566C8.41575 5.51569 8.21227 5.59998 8.0001 5.59998C7.78792 5.59998 7.58444 5.51569 7.43441 5.36566C7.28438 5.21563 7.2001 5.01215 7.2001 4.79998C7.2001 4.5878 7.28438 4.38432 7.43441 4.23429C7.58444 4.08426 7.78792 3.99998 8.0001 3.99998C8.21227 3.99998 8.41575 4.08426 8.56578 4.23429C8.71581 4.38432 8.8001 4.5878 8.8001 4.79998ZM7.2001 7.19998C6.98792 7.19998 6.78444 7.28426 6.63441 7.43429C6.48438 7.58432 6.4001 7.7878 6.4001 7.99998C6.4001 8.21215 6.48438 8.41563 6.63441 8.56566C6.78444 8.71569 6.98792 8.79998 7.2001 8.79998V11.2C7.2001 11.4121 7.28438 11.6156 7.43441 11.7657C7.58444 11.9157 7.78792 12 8.0001 12H8.8001C9.01227 12 9.21575 11.9157 9.36578 11.7657C9.51581 11.6156 9.6001 11.4121 9.6001 11.2C9.6001 10.9878 9.51581 10.7843 9.36578 10.6343C9.21575 10.4843 9.01227 10.4 8.8001 10.4V7.99998C8.8001 7.7878 8.71581 7.58432 8.56578 7.43429C8.41575 7.28426 8.21227 7.19998 8.0001 7.19998H7.2001Z"
                  fill="#363D4D"
                />
              </svg>
              {{ column.displayName }}
            </v-th>
          </thead>
          <tbody
            slot="body"
            slot-scope="{ displayData }"
            v-if="displayData.length"
          >
            <tr
              v-for="(row, i) in displayData"
              :key="i"
              @click="
                $helpers.navigateOrNewTab(navigateURL(row), $router, $event)
              "
              style="z-index: 0"
            >
              <td class="fs-sm fw-semibold">
                {{ row.agencyName || row.name }}
              </td>
              <td class="fs-sm f-capitalize">
                {{ row.tierName || '-' }}
              </td>
              <td class="fs-sm relative">
                <div class="block" style="max-width: fit-content;">
                  <i
                    class="fa fa-circle mr-xs"
                    :class="row.status | circleClass"
                  />
                  {{ row.status | status }}
                </div>
              </td>
              <td
                class="fs-sm relative"
                v-if="columns.some(col => col.name === 'featured')"
              >
                <div class="block pl-8" style="max-width: 150px">
                  {{ row.featured | featured }}
                </div>
              </td>
              <td class="fs-sm relative">
                <div class="block pl-8" style="max-width: fit-content;">
                  {{
                    (row.completeness || '-') + (row.completeness ? '%' : '')
                  }}
                </div>
              </td>
            </tr>
          </tbody>
          <tbody
            style="padding: 1em; display: block"
            class="fs-sm fw-semibold fc-medium"
            v-else
          >
            No partners!
          </tbody>
        </v-table>

        <smart-pagination
          :currentPage.sync="currentPage"
          :count="count"
          :pageSize="pageSize"
          v-on:update:currentPage="pageChanged($event)"
          :boundaryLinks="count > 500"
        />
      </div>
      <Modal
        title="Profile completeness"
        description="Now you can tell how complete a profile is by checking the percentage indicated on the table, it's that simple."
        @primary-click="modalShowing = false"
        @secondary-click="modalShowing = false"
        @close-modal="modalShowing = false"
        :modal-showing="modalShowing"
      >
        <div class="py-6 px-8 border-t border-gray-lighter border-solid">
          <div class="mb-4">
            <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
              20% - Just started
            </h4>
            <p class="text-gray-gray text-sm">
              Your partner has accepted your invite and started completing their
              profile. The profile contains partner name, contact name and email
              address.
            </p>
          </div>
          <div class="mb-4">
            <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
              40% - Getting there
            </h4>
            <p class="text-gray-gray text-sm">
              The profile now also contains their website URL and a logo, a
              country and state or city.
            </p>
          </div>
          <div class="mb-4">
            <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
              60% - Got the basics
            </h4>
            <p class="text-gray-gray text-sm">
              The profile has a summary added too.
            </p>
          </div>
          <div class="mb-4">
            <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
              80% - Almost done
            </h4>
            <p class="text-gray-gray text-sm">
              The profile has at least one filter option selected.
            </p>
          </div>
          <div class="mb-4">
            <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
              100% - Profile complete
            </h4>
            <p class="text-gray-gray text-sm">
              All fields have the minimum completed. Yay!
            </p>
          </div>
        </div>
      </Modal>
    </template>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Modal from '@/components/DesignSystem/Modal';
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import TableToolbar from '@/components/Dashboard/TableToolbar';
import Logo from '@/components/SpinningLogo';
import LinkIcon from '@/components/DesignSystem/LinkIcon';
import Button from '@/components/DesignSystem/Button';
import { createNamespacedHelpers } from 'vuex';
const {
  mapGetters,
  mapActions,
  mapState,
  mapMutations,
} = createNamespacedHelpers('agencyProfiles');

export default {
  name: 'Partners',
  components: {
    TableToolbar,
    DashboardHeader,
    Modal,
    Logo,
    Button,
    LinkIcon,
  },
  directives: {
    ClickOutside,
  },
  computed: {
    ...mapGetters({
      columns: 'getColumns',
      rows: 'getRows',
      filters: 'getFilters',
      savedPage: 'getSavedPage',
    }),
    ...mapState(['count', 'pageSize', 'loading']),
    tiers() {
      return this.$store.getters['tiers'];
    },
  },
  created() {
    this.setSort('-created');
    this.fetchPartners(1);
    if (this.savedPage) {
      if (this.savedPage) {
        this.currentPage = this.savedPage;
      } else {
        this.currentPage = 1;
      }
    }
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 3,
      dropdownOpen: false,
      modalShowing: false,
    };
  },
  filters: {
    status(value) {
      switch (value) {
        case 'I':
          return 'Invited';
        case 'P':
          return 'Public';
        case 'H':
          return 'Hidden';
        case 'S':
          return 'Searchable';
        case 'N':
          return 'Hidden';
        default:
          return 'Invited';
      }
    },
    featured(value) {
      if (value) {
        return 'Yes';
      }
      return '-';
    },
    circleClass(value) {
      switch (value) {
        case 'H':
          return 'fc-medium';
        case 'N':
          return 'fc-medium';
        case 'P':
          return 'fc-green';
        case 'S':
          return 'fc-green';
        default:
          return 'fc-light';
      }
    },
  },
  methods: {
    ...mapActions([
      'updateQueryAndFilter',
      'fetchPartners',
      'savePage',
      'sortResults',
    ]),
    ...mapMutations(['setSort']),
    sortChange(key) {
      this.sortResults(key);
      this.currentPage = 1;
    },
    filterRows(fields, value, type) {
      if (!fields && type == 'name') {
        fields = ['agencyName', 'name'];
      }
      let exact = false;
      if (type === 'tier') {
        exact = true;
      }
      this.currentPage = 1;
      this.updateQueryAndFilter({ fields, value, type, exact });
    },
    navigateURL(row) {
      return row.inviteName
        ? `partners/invitations/${row.id}`
        : `partners/${row.id}`;
    },
    openDropdown() {
      return (this.dropdownOpen = true);
    },
    closeDropdown() {
      return (this.dropdownOpen = false);
    },
    sortAgenciesAndInvites(a, b) {
      const first = a.agencyName || a.name;
      const second = b.agencyName || b.name;

      if (!first && second) return 1;
      if (second && !first) return -1;
      if (!first && !second) return 1;

      return first.localeCompare(second, undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    },
    pageChanged(page) {
      this.$store.dispatch('fetchFilters');
      this.fetchPartners(page);
    },

    copyToClipboard(url) {
      navigator.clipboard.writeText(url).then(() => {
        this.$store
          .dispatch('showUserMessage', {
            success: true,
            title: 'Link copied!',
          })
          .catch(() => {
            this.$store.dispatch('showUserMessage', {
              success: false,
              title: 'Sorry!',
              message: 'Something went wrong copying your Get Listed link.',
            });
          });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.savePage(this.currentPage);
    next();
  },
};
</script>

<style scoped>
.dropdown-enter-active {
  transition: opacity 200ms ease-out, scale 100ms ease-out;
  opacity: 0;
  scale: 0.9;
}

.dropdown-enter-to {
  opacity: 1;
  scale: 1;
}

.dropdown-leave-active {
  transition: opacity 150ms ease-in;
  opacity: 1;
  scale: 1;
}

.dropdown-leave-to {
  opacity: 0;
  scale: 0.9;
}
</style>
